module.exports = __webpack_public_path__ + "img/1cube truck to 1bakkie.a1b6577a.svg";